
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "OttawaSAH",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/ER/OttawaSAH.vue